<template>
  <div>
    <el-dialog
      :title="title"
      align="center"
      :visible.sync="dialogVisible"
      width="40%"
      v-dialogDrag
      top="20px"
      :before-close="handleClose"
      :modal-append-to-body="false"
    >
      <div class="media-box" id="media-box" v-if="videoShow"></div>
      <div class="media-box" id="img-box" v-if="imgShow">
        <img :src="mediaUrl" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import videojs from "video.js";
import "videojs-contrib-hls";
import imageURLDecrypt from "@/components/imageURLDecrypt";

import baseConfig from "@/utils/serverUrlConfig";
import { getHlsTechOptions, toHlsSource } from "@/utils/hlsPlayer";

export default {
  data() {
    return {
      dialogVisible: false,
      imgShow: true,
      mediaUrl: "",
      videoShow: false,
      title: "封面图查看",
      myData: []
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    }
  },
  mounted() {},
  methods: {
    handleClose() {
      if (this.player) {
        this.player.dispose();
      }
      this.dialogVisible = false;
      this.imgShow = false;
      this.videoShow = false;
      this.mediaUrl = "";
    },
    async open(url, type) {
      this.dialogVisible = true;
      if (type === "img") {
        this.imgShow = true;
        this.videoShow = false;
        this.title = "封面图查看";
        const src = await imageURLDecrypt(url);
        this.mediaUrl = src;
      } else {
        this.imgShow = false;
        this.videoShow = true;
        this.title = "视频查看";
        this.mediaUrl =
          baseConfig.videoURL +
          baseConfig.sourceURL +
          url +"?token=" +this.token;
          // +"?token=" +this.token
        this.$nextTick(function() {
          document.getElementById("media-box").innerHTML =
            '<video id="my-video"  class="video-js vjs-default-skin" controls preload="auto" style="width:100%;height:100%"></video>';
          this.player = videojs(
            "my-video",
            {
              bigPlayButton: false,
              textTrackDisplay: false,
              posterImage: true,
              errorDisplay: true,
              controlBar: true,
              ...getHlsTechOptions()
            },
            function() {
              this.play();
            }
          );
          this.player.src(toHlsSource(this.mediaUrl));
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.my_data {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.media-box {
  width: 100%;
  height: 400px;
  text-align: center;
  overflow: hidden;
  img {
    height: 100%;
    max-width: 100%;
  }
  #my-video {
    width: 100% !important;
    height: 100% !important;
    border: none !important;
  }
}
</style>
